export default function updateCouponAdminReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_COUPON_ADMIN_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_COUPON_ADMIN_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_COUPON_ADMIN_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}